interface Props {
  condition?: boolean
  wrapper: any
  children: any
}

export const ConditionalWrapper = ({ condition, wrapper, children }: Props) =>
  condition ? wrapper(children) : children
